import React from 'react';
import { urlMap, urlConstructor } from 'routes/urlMap';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { featureEnabled } from 'utilities/featureFlag';
import { DMD_MODULAR_ORDER_FORM } from 'constants/featureFlags';
import { NavLink } from '../components';

export const PostJobLink = (props) => {
  const isModularFormEnabled = featureEnabled(DMD_MODULAR_ORDER_FORM);
  let path = urlMap.POSITION_LISTINGS;
  if (isModularFormEnabled) path = urlMap.CREATE_MODULAR_ORDER;

  return (
    <NavLink
      {...props}
      icon={faCirclePlus}
      textPath="navbar.new_job"
      displayPath="/job_requests/new"
      url={urlConstructor(path)}
      name="post-jobs"
    />
  );
};
